import Modal from './Modal';
export type { ModalProps } from './Modal';
export type { ModalBodyProps } from './ModalBody';
export type { ModalDialogProps } from './ModalDialog';
export type { ModalFooterProps } from './ModalFooter';
export type { ModalHeaderProps } from './ModalHeader';
export type { ModalTitleProps } from './ModalTitle';
export default Modal;
